import './styles/App.css';
import SignIn from './signin';
import Menu from './menu';
import Heading from './heading';
import RightSide from './RightSide';
import React from 'react';
import { useState, useEffect } from 'react';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { onAuthStateChanged, fetchSignInMethodsForEmail } from "firebase/auth";

import 'firebase/compat/firestore';

import { set } from 'firebase/database';
import { getDatabase, ref, push, onValue } from "firebase/database";

var config =  {
  apiKey: "AIzaSyCfi4QUolIGWsxiPuAE5weRCvcfQRU9t5g",
  authDomain: "midterm-422c7.firebaseapp.com",
  projectId: "midterm-422c7",
  storageBucket: "midterm-422c7.appspot.com",
  messagingSenderId: "344161442668",
  appId: "1:344161442668:web:cdfb79c642a3ccbdd7f149"
};
firebase.initializeApp(config);
function App() {
const auth = firebase.auth();
const [email, setEmail] = useState("");
const [uid, setUid] = useState(0);
const [login, setLogin] = useState(false);
const [show_room, setShow_room] = useState(-1);
const [room_id, setRoom_id] = useState(0);
const [chat_room, setChat_room] = useState([]);

const db = getDatabase();
const handle_room_select = (select_room_id) => { 
  console.log("select room : " + select_room_id);
  setShow_room(select_room_id);
}
const handle_add_room = (receiver, name) => {
  fetchSignInMethodsForEmail(auth, receiver).then((result) => {
    if(result.length == 0)
      alert("This email is not registered");
    else if(receiver == email)
      alert("You cannot invite yourself");
    else if (receiver != "") {
        var db_ref = ref(db, `rooms/${room_id}/members`);
        var db_ref2 = ref(db, `rooms/${room_id}/name`);
        var db_ref3 = ref(db, `rooms/${room_id}/chats`);
    
        var new_ref = push(db_ref);
        var new_ref2 = push(db_ref2);
        var new_ref3 = push(db_ref3);
    
        set(new_ref, firebase.auth().currentUser.email);
        set(new_ref2, name);
    
        var new_chat = {
          data: "dummy",
          sender: email,
          type: 0,
          unsend: true,
          notify: true
      };
        set(new_ref3, new_chat);
    
        new_ref = push(db_ref);
        set(new_ref, receiver);
      }
    console.log(result);
  }).catch((error) => {
    alert("Please type in the correct email");
    console.log(error);
  });
   

  
}

const handle_invite = (receiver, invite_room) => {

  fetchSignInMethodsForEmail(auth, receiver).then((result) => {
    if(result.length == 0)
      alert("This email is not registered");
    else{
      var db_ref = ref(db, `rooms/${invite_room}/members`);
      var is_member = false;
      onValue(db_ref, (snapshot) => {
        const data = snapshot.val();
        Object.keys(data).map((key) => {
          if (data[key] == receiver) {
            is_member = true;
          }
        });
      });
      if (receiver != "" ) {
        if(is_member)
          alert("The email is already a member");
        else
        {
          var db_ref = ref(db, `rooms/${invite_room}/members`);
          var new_ref = push(db_ref);
          set(new_ref, receiver);
        }
        
      }
    }
    

  }).catch((error) => {
    alert("Please type in the correct email");
    console.log(error);
  });
};

useEffect(()=>{
  onAuthStateChanged(auth, (user) => {
      if (user) {
        setLogin(true);
        setEmail(user.email);
      } else {
        console.log("user is logged out")
        setLogin(false);
        setShow_room(-1);
      }
    });  
}, []);

useEffect(() => {
  var db_ref = ref(db, `rooms`);
  onValue(db_ref, (snapshot) => {
      const data = snapshot.val();
      var new_members = [];
      setRoom_id(data.length);
      Object.keys(data).map((key, id) => {
        var name;
        Object.keys(data[key].name).map((key2) => {
          name = data[key].name[key2];
        });
        Object.keys(data[key].members).map((key2) => {
          if (data[key].members[key2] == firebase.auth().currentUser.email) {
            new_members.push({id: id, name: name});
          }
        });
      });  
      setChat_room(new_members);
    }); 
   }, [login]);

  return(
    login ? 
      (<div> 
        <Heading handle_add_room={handle_add_room} user_email={email}/> 
        <div className='main_page'> 
          <Menu handle_room_select={handle_room_select} email={firebase.auth().currentUser.email} members={chat_room}/> 
          <RightSide room_id={show_room} user_email={firebase.auth().currentUser.email} handle_invite={handle_invite}/>
        </div> 
      </div>)  : <SignIn />
  );
}
export default App;